import React, { createContext, useContext, useEffect, useState } from 'react';
import { initFirebase } from '../utils/firebaseUtils';
// import { Analytics } from 'firebase/analytics';
// import { FirebaseApp } from 'firebase/app';
// import { getAuth } from "firebase/auth";

interface FirebaseContextType {
  isInitialized: boolean;
}

const FirebaseContext = createContext<FirebaseContextType>({ isInitialized: false
  // , firebaseApp: null, analytics: null 
});

export const FirebaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        await initFirebase();
        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize Firebase:', error);
      }
    };

    initialize();
  }, []);

  // {/* <FirebaseContext.Provider value={{ isInitialized, firebaseApp, analytics }}> */}
  return (
    <FirebaseContext.Provider value={{ isInitialized }}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => useContext(FirebaseContext);